import React, { useCallback, useMemo, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { GridColumn } from "@progress/kendo-react-grid";

import { PayerBinSetupForm } from "./PayerBinSetupForm";
import ErrorHandler from "../../../components/core/ErrorHandler";
import Accordion from "../../../components/Accordion";
import SharedMainSelectableClientGrid from "shared/components/grids/clientGrid/SharedMainSelectableClientGrid";
import { TooltipCell } from "../../../components/grid/Kendo/CustomKendoGridCells";
import {
  DefaultDateColumnWidth,
  DefaultBooleanOrShortWidthColumnWidth,
  DefaultWideColumnWidth,
} from "../../../components/grid/Kendo/KendoGridAndColumnConstants";
import useGridDataStateResetProcessing from "shared/hooks/useGridDataStateResetProcessing";
import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";

export default function PayerBinSetup() {
  const [error, setError] = useState({});
  const [submittedFormData, setSubmittedFormData] = useState({});

  const {
    gridDataStateResetProcessingInitiated,
    InitiateGridDataStateReset,
    GridDataStateResetCompleted: onGridDataStateResetCompleted,
  } = useGridDataStateResetProcessing();

  function handleFormSubmit(formData) {
    setError({});
    setSubmittedFormData(formData);
    InitiateGridDataStateReset();
  }

  const apiParams = useMemo(() => {
    if (IsNullOrEmpty(submittedFormData.mmids)) {
      return {};
    }
    return { mmids: submittedFormData.mmids };
  }, [submittedFormData]);

  const onGridSourceDataChanged = useCallback((data) => {
    if (data && data.length === 0) {
      setError({ status: 201, Message: "No data found for given parameters" });
    } else {
      setError({});
    }
  }, []);

  return (
    <div className="feature-tab" id="payer-bin-setup">
      <ErrorHandler error={error} onClose={() => setError({})} />
      <Accordion defaultExpanded label="Search & Filter">
        <Row>
          <Col className="higher-zindex-filters">
            <PayerBinSetupForm handleFormSubmit={handleFormSubmit} />
          </Col>
        </Row>
      </Accordion>
      <Row>
        <Col className="tight-grid multi-line-filter">
          <SharedMainSelectableClientGrid
            apiGetEndpoint={"api/MemberBin/GetInitDates"}
            apiParameters={apiParams}
            styleOverride={{ minHeight: "19em", maxHeight: "50em" }}
            useQueryOptions={{ refetchOnWindowFocus: false }}
            onGridSourceDataChangedCallback={onGridSourceDataChanged}
            gridDataStateResetProcessingInitiated={
              gridDataStateResetProcessingInitiated
            }
            onGridDataStateResetCompleted={onGridDataStateResetCompleted}
            exportFileNamePrefix={"PayerBinSetup"}
          >
            <GridColumn
              field="location"
              title="Location"
              width={DefaultWideColumnWidth()}
              headerCell={TooltipCell}
            />
            <GridColumn
              field="ncpdp"
              title="NCPDP"
              width={DefaultBooleanOrShortWidthColumnWidth()}
              headerCell={TooltipCell}
            />
            <GridColumn
              field="bin"
              title="BIN"
              width={DefaultBooleanOrShortWidthColumnWidth()}
              headerCell={TooltipCell}
            />
            <GridColumn
              field="initDate"
              title="Init Date"
              width={DefaultDateColumnWidth()}
              filter="date"
              format="{0:d}"
              headerCell={TooltipCell}
            />
          </SharedMainSelectableClientGrid>
        </Col>
      </Row>
    </div>
  );
}
